export default __webpack_public_path__ + "static/main-product-06ca8976e28c4de8f24b4cb8df4d261b.png";